if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.querySelectorAll('[type="submit"]').forEach((button) => button.addEventListener('click', () => {
        this.submitButton = button;
      }));
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.form.dataset.submitting === 'true') return;

      const submitButton = evt.submitter || this.submitButton;
      const isBuyNow = submitButton && submitButton.name === 'buy_now';
      let redirectingToCheckout = false;

      if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;
      this.form.dataset.submitting = 'true';

      this.handleErrorMessage();

      const allSubmitButtons = this.form.querySelectorAll('[type="submit"]');
      allSubmitButtons.forEach((button) => button.setAttribute('aria-disabled', true));
      if (submitButton) {
        submitButton.classList.add('loading');
        const spinner = submitButton.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.error = true;
            this.handleErrorMessage(response.description);

            const soldOutMessage = submitButton && submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            return;
          }

          if (isBuyNow) {
            redirectingToCheckout = true;
            const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root.replace(/\/+$/, '') : '';
            window.location.href = `${root}/checkout`;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (redirectingToCheckout) return;
          delete this.form.dataset.submitting;
          if (submitButton) {
            submitButton.classList.remove('loading');
            const spinner = submitButton.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.add('hidden');
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) allSubmitButtons.forEach((button) => button.removeAttribute('aria-disabled'));
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
